export const FIELDS_TO_COMPARE = [
  'birthLastName',
  'birthFirstName',
  'otherFirstNames',
  'birthDate',
  'birthPlaceCode',
  'inseeNumber',
  'assigningAuthority', // oid
]

export const INS_LOG_FIELD_MAPPINGS = [
  "sex",
  'birthLastName',
  'birthFirstName',
  'otherFirstNames',
  'birthDate',
  'birthPlaceCode',
  'inseeNumber',
  'assigningAuthority', // oid
]

